import React from 'react'

import * as S from './styles'

export interface IBreadcrumbItem {
	linkPath: string
	title: string
}
interface P {
	items: readonly IBreadcrumbItem[]
	currentTitle?: string
}

const Breadcrumb = ({ currentTitle, items }: P) => (
	<S.Breadcrumbs>
		{items.map(({ linkPath, title }) => (
			<S.Link key={title} to={linkPath}>
				{title}
			</S.Link>
		))}
		{currentTitle && <span>{currentTitle}</span>}
	</S.Breadcrumbs>
)

export { Breadcrumb }
